export default function toLowerCase(str: string): string {
  return str.toLowerCase();
}
